
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

import MenuBookMenuItemTile from "../menu-book/menu-book-menu-item-tile.vue";
import ResponsiveDialog from "./responsive-dialog.vue";
export default {
  components: { ResponsiveDialog, MenuBookMenuItemTile },
  props: {
    dialog: false
  },
  computed: {
    ...mapState("order", ["cart", "restaurantDetails"]),
    ...mapGetters("order", ["getUnavailableItems"]),

    isAllItemsUnavailable() {
      return this.getUnavailableItems.length === this.cart.items.length;
    }
  },
  methods: {
    ...mapActions("order", ["updateCart"]),
    ...mapActions("menu", ["getMenuListForOrder", "getCategories"]),
    ...mapMutations("menu", ["SET_MENU_LOADING"]),
    async fetch() {
      if (!this.restaurantDetails.location) return;
      this.SET_MENU_LOADING(true);
      await Promise.all([
        this.getCategories({
          forceFetch: true,
          id: this.restaurantDetails.location?.id
        }),
        this.getMenuListForOrder({
          forceFetch: true,
          brandId: this.restaurantDetails.restaurant_id
        })
      ]);
      this.SET_MENU_LOADING(false);
    },
    async removeUnavailableItems() {
      const updatedItems = this.getUnavailableItems.map((item) => ({
        ...item,
        menuId: item.id,
        quantity: 0
      }));

      this.updateCart({ menuItems: updatedItems });
      this.$emit("close-dialog");
      await this.fetch();
    },
    handleAddItem() {
      this.removeUnavailableItems();
      this.$router.push(`/order/menu`);
    },
    handleContinue() {
      this.removeUnavailableItems();
    }
  }
};
